import {
  IdleAssetReview,
  IdleAssetReviewManager,
  IdleAssetReviewManagerCondition,
} from 'models/asst/IdleAssetReview';
import { CommonRequest, CommonResponse, Method, ServiceName } from 'models/common/RestApi';
import { callApi } from 'utils/ApiUtil';
import { IdleAssetReviewResult } from '../../models/asst/IdleAssetReviewResult';

/**
 * 불용자산관리 > 법인별 진행 현황 목록 조회
 * @param rvwReqId
 * @param asstTpCd
 * @param eqpId
 */
export const findAssetReviewStatus = async (rvwReqId: string, asstTpCd: string, eqpId: string) => {
  const params = {
    rvwReqId: rvwReqId,
    asstTpCd: asstTpCd,
    eqpId: eqpId,
  };
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/asst/review-status`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...params }),
  };

  const response: CommonResponse<IdleAssetReview[]> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as IdleAssetReview[];
};

/**
 * 불용자산관리 > 법인별 검토 현황 목록 조회
 * @param rvwReqId
 * @param asstTpCd
 * @param eqpId
 */
export const findAssetReview = async (rvwReqId: string, asstTpCd: string, eqpId: string) => {
  const params = {
    rvwReqId: rvwReqId,
    asstTpCd: asstTpCd,
    eqpId: eqpId,
  };
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/asst/review`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...params }),
  };

  const response: CommonResponse<IdleAssetReview[]> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as IdleAssetReview[];
};

/**
 * 법인별 담당자 조회
 * @param condition
 */
export const findIdleAssetReviewManager = async (condition?: IdleAssetReviewManagerCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/asst/review-manager`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };

  const response: CommonResponse<IdleAssetReviewManager[]> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as IdleAssetReviewManager[];
};

/**
 * 법인별 담당자 저장
 * @param idleAssetReviewManager
 */
export const saveIdleAssetReviewManager = async (
  idleAssetReviewManager?: IdleAssetReviewManager[]
) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/asst/review-manager`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: idleAssetReviewManager,
  };

  const response: CommonResponse<IdleAssetReviewManager[]> = await callApi(request);

  return response;
};

/**
 * [고도화] 2025.10.30 불용자산 대상 법인,부서,공정 조회 (사용자별)
 * @param condition
 */
export const getAsstRvwReplyUserDept = async (condition?: IdleAssetReviewManagerCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/asst/getAsstRvwReplyUserDept`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };

  const response: CommonResponse<IdleAssetReviewResult[]> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as IdleAssetReviewResult[];
};
